<template>
    <div>
        <div :class="view_class_view.div_container">

            <div class="flex flex-col" v-show="show_inputs.rfc">
                <label :class="view_class_view.input_label" for="input_RFC_personal_info">R.F.C.:</label>
                <input type="text" id="input_RFC_personal_info"
                class="uppercase"
                v-maska="'AAAA######XXX'" 
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _personalDataModelValidation$.rfc.$error,
                    [view_class_view.input_class.default + view_class_view.input_class.valid]:!_personalDataModelValidation$.rfc.$invalid,
                    [view_class_view.input_class.default ]: _personalDataModelValidation$.rfc.$invalid && !_personalDataModelValidation$.rfc.$error  }"
                @blur="_personalDataModelValidation$.rfc.$validate"
                @input="getDateByRFC(personalDataModel.rfc.toUpperCase())"
                v-model="personalDataModel.rfc">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.rfc.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
            <slot class="flex flex-col" v-if="showSlot">

            </slot>

            <div class="flex flex-col" v-show="show_inputs.curp">
                <label :class="view_class_view.input_label" for="input_CURP_personal_info">C.U.R.P.:</label>
                <input type="text" id="input_CURP_personal_info"
                class="uppercase"
                v-maska="'AAAA######AAAAAAXX'"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _personalDataModelValidation$.curp.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!_personalDataModelValidation$.curp.$invalid,
                [view_class_view.input_class.default ]: _personalDataModelValidation$.curp.$invalid && !_personalDataModelValidation$.curp.$error  }"
                @blur="_personalDataModelValidation$.curp.$validate"
                @input="personalDataModel.curp.toUpperCase()"
                v-model="personalDataModel.curp">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.curp.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="flex flex-col" v-show="show_inputs.dateBirth">
                <label :class="view_class_view.input_label" for="input_date_birth_personal_info">Fecha de Nacimiento:</label>
                <label type="text" id="input_date_birth_personal_info" v-bind:class="view_class_view.input_class.default + 'block bg-gray-200 text-gray-600'"> {{ personalDataModel.dateBirth }} </label>
            </div>

            <div class="flex flex-col" v-show="show_inputs.date_picker">
                <label class="mb-2" :class="view_class_view.input_label" for="picker_date_birth_personal_info">Fecha de Nacimiento:</label>
                <date-picker
                    class="block mt-2"
                    value="11/11/1995"
                    simple
                    placeholder="Fecha inicio"
                    locale="es"
                    v-model="personalDataModel.dateBirth"
                    input-format="DD/MM/YYYY"
                    id="picker_date_birth_personal_info"
                    @change="selectDate($event)"
                    :localeConfig="{
                      es: {
                        displayFormat: 'DD/MM/YYYY',
                          lang: {
                            year: 'Año',
                            month: 'Mes',
                            day: 'Día',
                            label: '',
                            submit: 'Seleccionar',
                            cancel: 'Cancelar',
                            now: 'Hoy',
                            nextMonth: 'Siguiente',
                            prevMonth: 'Anterior',
                          },
                        }
                    }" />

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.dateBirth.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="flex flex-col" v-show="show_inputs.paternalName">
                <label :class="view_class_view.input_label" for="input_last_name_personal_info">Apellido Paterno:</label>
                <input type="text" id="input_last_name_personal_info"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _personalDataModelValidation$.paternalName.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!_personalDataModelValidation$.paternalName.$invalid,
                [view_class_view.input_class.default ]: _personalDataModelValidation$.paternalName.$invalid && !_personalDataModelValidation$.paternalName.$error  }"
                @blur="_personalDataModelValidation$.paternalName.$validate,formatCamelize(personalDataModel.paternalName,'paternalName')"
                v-model="personalDataModel.paternalName">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.paternalName.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="flex flex-col" v-show="show_inputs.maternalName">
                <label :class="view_class_view.input_label" for="input_mothers_last_name_personal_info">Apellido Materno:</label>
                <input type="text" id="input_mothers_last_name_personal_info"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _personalDataModelValidation$.maternalName.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!_personalDataModelValidation$.maternalName.$invalid,
                [view_class_view.input_class.default ]: _personalDataModelValidation$.maternalName.$invalid && !_personalDataModelValidation$.maternalName.$error  }"
                @blur="_personalDataModelValidation$.maternalName.$validate,formatCamelize(personalDataModel.maternalName,'maternalName')"
                v-model="personalDataModel.maternalName">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.maternalName.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="flex flex-col" v-show="show_inputs.name">
                <label :class="view_class_view.input_label" for="input_first_name_personal_info">Primer Nombre:</label>
                <input type="text" id="input_first_name_personal_info"
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _personalDataModelValidation$.firstName.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!_personalDataModelValidation$.firstName.$invalid,
                [view_class_view.input_class.default ]: _personalDataModelValidation$.firstName.$invalid && !_personalDataModelValidation$.firstName.$error  }"
                @blur="_personalDataModelValidation$.firstName.$validate,formatCamelize(personalDataModel.firstName,'firstName')"
                v-model="personalDataModel.firstName">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.firstName.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="flex flex-col" v-show="show_inputs.secondName">
                <label :class="view_class_view.input_label" for="input_second_name_personal_info">Segundo Nombre:</label>
                <input type="text" id="input_second_name_personal_info" 
                v-bind:class="{[ view_class_view.input_class.default + view_class_view.input_class.no_valid ]: _personalDataModelValidation$.secondName.$error,
                [view_class_view.input_class.default + view_class_view.input_class.valid]:!_personalDataModelValidation$.secondName.$invalid,
                [view_class_view.input_class.default ]: _personalDataModelValidation$.secondName.$invalid && !_personalDataModelValidation$.secondName.$error  }"
                @blur="_personalDataModelValidation$.secondName.$validate,formatCamelize(personalDataModel.secondName,'secondName')"
                v-model="personalDataModel.secondName">

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.secondName.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="flex flex-col" v-show="show_inputs.gender">
                <ChooseButton
                    ref="RefChooseButton"
                    :buttons="buttonsGender"
                    v-on:choose-button="getValueChooseButton($event)"
                    label="Género"
                    :buttons_styles="buttons_styles"
                />

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of _personalDataModelValidation$.gender.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { ref } from 'vue';
import ChooseButton from "./Forms/ChooseButton.vue";
import moment from "moment";
export default({
    name:"DatosPersonalesComponent",
    props:{
        showSlot: {
            type: Boolean,
            default(){
                return false;
            }
        },
        view_class_view:{
            type: Object,
            default(){
                return {
                    input_label: "",
                    input_class:{
                        valid:"border-blue-600",
                        no_valid:"border-red-600",
                        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
                    },
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                    div_container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-5 my-8 ml-8",
                }
            }
        },
        validations: {
            type: Object,
            default(){
                return {};
            }
        },
        show_inputs:{
            type: Object,
            default(){
                return {
                    rfc: true,
                    curp: true,
                    dateBirth: true,
                    paternalName: true,
                    maternalName: true,
                    name: true,
                    secondName: true,
                    gender: true
                };
            }
        },
        buttons_styles:{
            type: Object,
            default(){
                return {
                    buttonSelected:"",
                    activeColorBackground: '#EA7F0B !important',
                    inactiveColorBackground: '#FFFFFF !important',
                    activeColorText: '#FFFFFF !important',
                    inactiveColorText: '#EA7F0B !important',
                    activeBorderColor: '#EA7F0B',
                    inactiveBorderColor: '#EA7F0B'
                };
            }
        }
    },
    components:{
        ChooseButton
    },
    setup(props){
       
        const RefChooseButton = ref(null)

        let personalDataModel = ref({ rfc:"", curp:"", dateBirth:"", paternalName:"", maternalName:"", firstName:"", secondName:"", gender:"" });
        const _personalDataModelValidation$ = useVuelidate(props.validations,personalDataModel);

        const buttonsGender = [
            {
                id: "button_gender_male_personal_info",
                value: "masculino",
                text: "Hombre",
            },
            {
                id: "button_gender_female_personal_info",
                value: "femenino",
                text: "Mujer",
            },
        ];
        
        function getDateByRFC(rfc){
            if(rfc.length === 13){
                const date = new Date()
                const yearPlusOne = date.setFullYear(date.getFullYear() +1 )
                const yearPlusOneSub = new Date(yearPlusOne).getFullYear().toString().substring(2,4);
            
                const extractFullDate = rfc.substring(4, 10);
                const yearRFC = extractFullDate.substring(0, 2);
                const getYearFormat = yearPlusOneSub > yearRFC ? `20${yearRFC}`: `19${yearRFC}`

                
                const month = extractFullDate.substring(2, 4);
                const day = extractFullDate.substring(4, 6);

                const formatYear = `${day}/${month}/${getYearFormat}`;
                personalDataModel.value.dateBirth = formatYear;
            }
        }

        function getValueChooseButton(generSelected){
            personalDataModel.value.gender = generSelected;
        }

        function execute_validation() {
          this._personalDataModelValidation$.$validate();
          if(this._personalDataModelValidation$.$error){
            return false;
          }
          return personalDataModel.value;
        }

        function selectDate(event){
           personalDataModel.value.dateBirth = moment(event._d).format("YYYY-MM-DD");
        }

        function formatCamelize(str,node_key) {
            let response = ""
            if (str != "" && typeof str != 'undefined') {
              str = str.toString().toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function (match) {
                return match.charAt(match.length - 1).toUpperCase();
              });
              response = str.charAt(0).toUpperCase() + str.substring(1);
              personalDataModel.value[node_key] = response.replace(/([A-Z])/g, ' $1').trim();
            }
        }           

        return {
            personalDataModel,
            _personalDataModelValidation$,
            buttonsGender,
            getValueChooseButton,
            execute_validation,
            selectDate,
            getDateByRFC,
            RefChooseButton,
            formatCamelize
        }
    }

});
</script>